import React, { useEffect, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { getLinkToHomePage } from '../../lib/utils/reverse-routing';
import Paper from '../Paper';
import { ReactComponent as CheckCircleSvg } from './icons/check_circle.svg';
import {
  ContainerSuccess,
  WrapperSuccess,
  ContentSuccess,
  TitleSuccess,
  TextSuccess,
  FooterSuccess,
  InlineButton,
  StyledLink,
  StyledButton,
} from './styled';

export type SuccessProps = {
  helpCenterName: string;
  className?: string;
  onLeaveAnotherMessageClick: () => void;
};

const ContactFormSuccess = ({
  helpCenterName,
  onLeaveAnotherMessageClick,
  className,
}: SuccessProps) => {
  const { t } = useTranslation();
  const rootLevelLink = getLinkToHomePage();
  const [isEmbedded, setIsEmbedded] = useState(false);

  useEffect(() => {
    setIsEmbedded(window.self !== window.top);
  }, []);

  return (
    <WrapperSuccess className={`ghc-success-page ${className ?? ''}`}>
      <ContainerSuccess>
        <Paper.Wrapper disableBorderAndShadows>
          <Paper.Header>{t('contactUs')}</Paper.Header>
          <Paper.Content>
            <ContentSuccess>
              <CheckCircleSvg />
              <div>
                <TitleSuccess>{t('completedFlowTitle')}</TitleSuccess>
                <TextSuccess>
                  {t('reachOutSoon', { helpCenterName })}
                </TextSuccess>
              </div>
            </ContentSuccess>
            <FooterSuccess>
              <InlineButton onClick={onLeaveAnotherMessageClick}>
                {t('leaveAnotherMessage')}
              </InlineButton>
              {!isEmbedded && (
                <StyledLink {...rootLevelLink}>
                  <StyledButton>{t('backToHome')}</StyledButton>
                </StyledLink>
              )}
            </FooterSuccess>
          </Paper.Content>
        </Paper.Wrapper>
      </ContainerSuccess>
    </WrapperSuccess>
  );
};

export default ContactFormSuccess;
